


<div style="overflow: hidden; max-height: 200px; position: absolute; z-index: 1; pointer-events: none; width: 100%" *ngIf="showAnimation">
	<lottie-anim #endAnim [options]="{animation: 'sent', autoplay: true, loop: false, speed: 1.7 }" [height]="250" style="position: relative; top:-20px;"></lottie-anim>
</div>

<div class="px-3 py-2" >

	<div class="my-panel no-shadow _bg ">
		<div class="my-panel-body" style="font-size:0.9rem;">
			<div class="text-center mb-3" style="font-size: 20px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 1rem">
				<div class="mt-2 animated zoomIn"><img src="/assets/images/logo.svg" (mousedown)="runAnimation()"/></div>
				<div class="text-accent pre-wrap">{{ 'TO.end_success_title' | translate }}</div>
				<div class="flex-center-middle" *ngIf="$storage.resultOrder?.number">
					<span>{{ 'PO.ORDER_NO' | translate }}:</span>
					<b class=" text-accent">{{ $storage.resultOrder.number }}</b>
				</div>
			</div>

			<!--<p>{{'TO.end-success-description'}}</p>-->

			<app-tabit-order-info [options]="{from:'end'}" style="font-size: 1.0em"></app-tabit-order-info>


			<div class="mt-4 text-center" style="font-size: 1.0em">

				<a mat-stroked-button extended color=""  (click)="viewBill()" class="shadow-sm">
					<mat-icon>receipt</mat-icon>
					{{'view_bill' | translate}}
				</a>


			</div>
		</div>
	</div>

	<div class="members-group-container my-panel _bg no-shadow animated fadeInUp" [ngClass]="{'_collapsed': itemsCollapsed}">
		<div class="_group-container-header" style="background-color: #fafafa !important;"  (mousedown)="itemsCollapsed = !itemsCollapsed">
			<div class="title ">
				<span>{{ 'TD.items-summary' | translate }}</span>
			</div>
			<mat-icon class="collapsicon-caret">keyboard_arrow_up</mat-icon>
		</div>
		<div class="_group-container-body">
			<div class="items-summary-content" style="padding:0; min-height: 80px;" >
				<div *ngFor="let offer of $storage.basket; let last = last" class="basket-row" [class.last]="last">
					<div class="_header">
						<div class="_counter text-highlight" *ngIf="offer.quantity > 1">
							{{offer.quantity}}*
						</div>
						<div class="_title">
							{{offer.name}}
						</div>
						<div class="_price text-highlight">
							{{offer.quantity * offer.total | lcurrency}}
						</div>
					</div>
					<div class="_summary">
						<div class="_summary-row" *ngIf="offer._item && offer._item.summary"><div>{{offer._item.summary.text}}</div></div>
						<ng-container *ngIf="offer.selectionSummary?.length">
							<div class="_summary-row" *ngFor="let group of offer.selectionSummary | filterBy:{_visible:true}">
								<b>{{group.name}}:</b>
								<div *ngFor="let item of group.items">
									<div>
										<span *ngIf="item.count > 1">{{item.count}}*</span>
										{{item.name || 'missing'}}
										<span class="inline m-near-xs" *ngIf="item._item.total > 0">+{{item._item.total | lcurrency}}</span>
									</div>
									<small class="block mb-1" *ngIf="item.$wasEdit && item._item.summary">{{item._item.summary.text}}</small>
								</div>
							</div>
						</ng-container>
						<div class="_summary-row" *ngIf="offer.offerRemrks">
							<i>*{{offer.offerRemrks}}</i>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="fixed-bottom m-3">
	<button mat-flat-button color="primary" class="lg btn-block" type="button" (mousedown)="_restartOrder()">
		{{'TO.add_another_order' |translate}}
	</button>
</div>
